// import React from 'react';
// import Plot from 'react-plotly.js';

// const TimeSeriesChart = ({ data }) => {
//     const predefinedSeries = [
//         {
//             x: [
//                 data.cartPrepStart,
//                 data.rooms_cleaning_1Start,
//                 data.break1Start,
//                 data.rooms_cleaning_2Start,
//                 // add other Start values
//             ].map(time => convertToTimeString(time)),
//             y: [1, 1, 1, 1], // corresponding Y-values
//             type: 'scatter',
//             mode: 'lines',
//             name: 'Predefined',
//             line: { color: 'lightblue' },
//         },
//     ];

//     const actualSeries = [
//         {
//             x: [
//                 data.cartPrepIn,
//                 data.rooms_cleaning_1In,
//                 data.break1In,
//                 data.rooms_cleaning_2In,
//                 // add other In values
//             ].map(time => convertToTimeString(time)),
//             y: [2, 2, 2, 2], // corresponding Y-values
//             type: 'scatter',
//             mode: 'lines',
//             name: 'Actual',
//             line: { color: 'red' },
//         },
//     ];

//     return (
//         <Plot
//             data={[...predefinedSeries, ...actualSeries]}
//             layout={{
//                 title: 'Time Series Comparison',
//                 xaxis: {
//                     title: 'Time',
//                     showgrid: true,
//                     zeroline: false,
//                     type: 'date',
//                 },
//                 yaxis: {
//                     title: 'Series',
//                     showline: true,
//                 },
//                 showlegend: true,
//                 legend: {
//                     x: 1,
//                     xanchor: 'right',
//                     y: 1,
//                 },
//             }}
//             style={{ width: '100%', height: '100%' }}
//         />
//     );
// };

// // Helper function to convert numeric time (e.g., 6.5) to a time string (e.g., "06:30")
// function convertToTimeString(time) {
//     const hours = Math.floor(time);
//     const minutes = (time - hours) * 60;
//     return `2024-08-29 ${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
// }




import React from 'react';
import ApexCharts from 'react-apexcharts';

const TimeSeriesChart = ({ data }) => {
    // Convert the time in decimal to a readable format like 'HH:MM AM/PM'
    const convertToTime = (decimal) => {
        const hours = Math.floor(decimal);
        const minutes = Math.floor((decimal - hours) * 60);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
        return `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
    };

    // Helper function to group tasks by category
    const groupTasks = (data, taskName) => {
        return Object.keys(data)
            .filter(key => key.toLowerCase().includes(taskName.toLowerCase()))
            .map(key => ({
                x: key,
                y: convertToTime(data[key])
            }));
    };

    // Group series by task category
    const cartPrepSeries = groupTasks(data, 'cartPrep');
    const wrapSeries = groupTasks(data, 'wrap');
    const roomsCleaningSeries = groupTasks(data, 'rooms_cleaning');
    const breakSeries = groupTasks(data, 'break');
    const lunchSeries = groupTasks(data, 'lunch');

    // Create series for the chart
    const series = [
        {
            name: 'CartPrep Time',
            data: cartPrepSeries,
            color: '#FF5733' // Color for CartPrep
        },
        {
            name: 'Wrap Time',
            data: wrapSeries,
            color: '#FF5733' // Same color for Wrap as CartPrep
        },
        {
            name: 'Rooms Cleaning Time',
            data: roomsCleaningSeries,
            color: '#3498DB' // Color for Rooms Cleaning
        },
        {
            name: 'Break Time',
            data: breakSeries,
            color: '#2ECC71' // Color for Breaks
        },
        {
            name: 'Lunch Time',
            data: lunchSeries,
            color: '#F1C40F' // Color for Lunch
        }
    ];


    console.log(series, 'series')
    const convertToDecimalHours = (timeString) => {
        const [time, period] = timeString.split(' ');
        let [hours, minutes] = time.split(':').map(Number);

        if (period === 'PM' && hours !== 12) {
            hours += 12;
        } else if (period === 'AM' && hours === 12) {
            hours = 0;
        }

        return hours + minutes / 60;
    };

    // Update the data structure to use decimal hours
    const updatedSeries = series.map(serie => ({
        ...serie,
        data: serie.data.map(point => ({
            ...point,
            y: convertToDecimalHours(point.y)
        }))
    }));
    const options = {
        chart: {
            type: 'bar', // Stacked column chart
            stacked: true,
            zoom: {
                enabled: true,
                type: 'x',
                autoScaleYaxis: true
            }
        },
        xaxis: {
            type: 'category',
            title: {
                text: 'Tasks'
            }
        },
        yaxis: {
            min: 0,
            // max: 48, // Since time is converted to decimal hours, range is 0-24
            labels: {
                formatter: (value) => {
                    const hours = Math.floor(value);
                    const minutes = Math.round((value - hours) * 60);
                    const ampm = hours >= 12 ? 'PM' : 'AM';
                    const displayHours = hours % 12 === 0 ? 12 : hours % 12;
                    return  hours //`${displayHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
                }
            },
            title: {
                text: 'Time (HH:MM AM/PM)'
            }
        },
        dataLabels: {
            enabled: false // Disable data labels on bars
        },
        tooltip: {
            x: {
                formatter: (val) => val
            },
            y: {
                formatter: (value) => {
                    const hours = Math.floor(value);
                    const minutes = Math.round((value - hours) * 60);
                    const ampm = hours >= 12 ? 'PM' : 'AM';
                    const displayHours = hours % 12 === 0 ? 12 : hours % 12;
                    return `${displayHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
                }
            }
        },
        colors: updatedSeries.map(serie => serie.color),
        stroke: {
            curve: 'smooth'
        }
    };

    return (
        <div>
            <ApexCharts
                options={options}
                series={updatedSeries}
                type="bar"
                height={350}
            />
        </div>
    );

};

export default TimeSeriesChart;
